var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/define-built-in.js
// module id = 714
// module chunks = 25